/**
 * webpacker/lib/storefront/wick_guide/triple_wicked.js
 */

import Wick from './wick.js';

class TripleWicked extends Wick {
  static get suffix() {
    return 'Triple Wicked';
  }
}

export default TripleWicked;
